import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { CssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/joy/CssBaseline';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Wrap the render in a setTimeout to ensure DOM is ready
setTimeout(() => {
  root.render(
    <React.StrictMode>
      <CssVarsProvider disableTransitionOnChange>
        <CssBaseline />
        <App />
      </CssVarsProvider>
    </React.StrictMode>
  );
}, 0);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
